import { SignalBinding } from "signals";
import betModel from "slotworks/model/bets/bet-model";
import { Services } from "slotworks/services/services";
import Idle from "slotworks/state-machine/standard/states/idle";

export default class GameiomIdle extends Idle {

    private signalBindings: SignalBinding[] = [];

    public onEnter() {
        super.onEnter();

        this.signalBindings.push(betModel.onCreditSizeChanged.add(() => this.clearTotalWin()));
        this.signalBindings.push(betModel.onCreditPerLineChanged.add(() => this.clearTotalWin()));
    }

    public onExit() {
        for (const binding of this.signalBindings) {
            binding.detach();
        }
        this.signalBindings = [];

        super.onExit();
    }

    private clearTotalWin() {
        Services.transaction.setTotalWin(0);
    }
}
